import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from 'react';
import { changedFundingQuoteTerms } from './quote-terms.js';
/** Replacement terms stay visible until explicit payment approval for this operation. */
export function useQuoteReview() {
  const $ = _c(5);
  const [quote, setQuote] = useState(null);
  const [review, setReview] = useState(null);
  const reviewedQuote = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (operationId, next, checked) => {
      const previous = reviewedQuote.current;
      const sameOperation = previous?.operationId === operationId;
      const termsChanged = sameOperation && (previous.termsChanged || changedFundingQuoteTerms(previous.quote, next));
      reviewedQuote.current = {
        operationId,
        quote: next,
        termsChanged
      };
      setQuote(next);
      setReview({
        ...checked,
        termsChanged
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const presentQuote = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function approveQuote() {
      if (reviewedQuote.current) {
        reviewedQuote.current.termsChanged = false;
      }
      setReview(_temp);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const approveQuote = t1;
  let t2;
  if ($[2] !== quote || $[3] !== review) {
    t2 = {
      quote,
      review,
      setQuote,
      setReview,
      presentQuote,
      approveQuote
    };
    $[2] = quote;
    $[3] = review;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(current) {
  return current ? {
    ...current,
    termsChanged: false
  } : null;
}